module.exports = __webpack_public_path__ + "img/title1.5940ebc1.png";